import React from 'react';
import * as Styled from './AScrimGradient.styles';
import { AScrimGradientProps, AScrimGradientDirection } from './AScrimGradient.types';

const COMPONENT_NAME = 'a-web-ui-kit-AScrimGradient';
const TEST_ID = 'web-ui-kit-AScrimGradient';

export const AScrimGradient = React.memo(function AScrimGradient({
  direction = AScrimGradientDirection.BottomToTop,
  ...rest
}: AScrimGradientProps) {
  return (
    <Styled.Wrapper
      {...rest}
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      aria-hidden="true"
      role="presentation"
    >
      <Styled.SafeZone data-testid={`${TEST_ID}-safe-zone`} />
      <Styled.GradientRamp $direction={direction} data-testid={`${TEST_ID}-gradient-ramp`} />
    </Styled.Wrapper>
  );
});

export { AScrimGradientDirection, TEST_ID as A_SCRIM_GRADIENT_TEST_ID };
